'use client';

import { Divider, Image } from '@nextui-org/react';
import clsx from 'clsx';
import { Noto_Serif } from 'next/font/google';

import { useClientTranslation } from '@/hook/translate';
import { mindful } from '@/types/audioResData';
import { MindfulAudioImg } from '@/config/img/mindfulAudio';
import MindScanBox from '@/components/DownBox/MindScanBox';

const notoSerif = Noto_Serif({ subsets: ['latin'] });


interface IProps {
  chapters: mindful.TChapter[];
  showTitle: boolean;
  title: string;
  play: () => void;
  pause: () => void;
  audioStatus: string;
}

export default function MdContent(props: IProps) {
  const { t } = useClientTranslation();
  return (
    <div className='content-wrap bg-[rgba(255,255,255,0.08)] rounded-[40px] mt-10 pt-[50px] pb-[35px]'>
      <h2 className='text-left text-34-46 font-extrabold '>
        
        {
            props.showTitle ? `${props.title} ${t('summaryAudio', 'mindfulAudio')}`
              : t('content', 'mindfulAudio')
          }
      </h2>
      <div className='flex w-full'>
        <div className='chapter-list flex-1 overflow-hidden'>
          {
            props.chapters?.map((item, index) => {
              return (
                <div key={item.id} className='pr-14'>
                  <div key={item.id} className='flex items-center h-[75px] border-b border-solid border-[rgba(255,255,255,0.5)]'>
                    <span className='text-2xl font-bold'>{t('chapter')} {index + 1}</span>
                    <span className={clsx('text-xl pl-4 flex-1 flex overflow-hidden', notoSerif.className)}>
                      <span className='w-full truncate'>{ item.section }</span>
                    </span>
                    {/* <Image src={index === 0 ? MindfulAudioImg.DetailPlay : MindfulAudioImg.Lock} className={index === 0 ? '' : 'cursor-not-allowed'} alt='play audio' width={40} height={40} /> */}
                    {
                  index === 0 ?
                    <>
                      {
                          <div 
                            className='h-14 flex items-center rounded-full' 
                          >
                             <span className='font-bold text-[#155FF9] text-18-24 pr-1'>{ t('playSample', 'mindfulAudio') }</span>
                            <Image 
                            src={ MindfulAudioImg.Stop  } 
                            className={ clsx(props.audioStatus === 'play' ? 'block cursor-pointer' : 'hidden') } 
                            alt='play audio'
                            radius='none'
                            width={ 40 } 
                            height={ 40 } 
                            onClick={ props.pause } 
                          />
                          
                          <Image 
                            src={ MindfulAudioImg.Play } 
                            alt='play audio' 
                            className={ clsx(props.audioStatus !== 'play' ? 'block cursor-pointer' : 'hidden') } 
                            radius='none'
                            width={ 40 } 
                            height={ 40 } 
                            onClick={ props.play } />
                          </div>
                      }
                    </>
                    :
                  <Image src={ MindfulAudioImg.Lock } className={ index === 0 ? '' : 'cursor-not-allowed' } alt='play audio' width={ 40 } height={ 40 } />
                }
                  </div>
                  {
                    index < props.chapters.length - 1 ?
                      <Divider /> : null
                  }
                </div>
              );
            })
          }
        </div>
        <MindScanBox className='shrink-0' />
      </div>
    </div>
  );
}
